import React from 'react';
import classNames from 'classnames';
import rpCookie from 'rp-cookie';
import { oneLineTrim } from 'common-tags';
import Package from './Package';
import SubscriptionUpgrade from '../../SubscriptionUpgrade';
import { withCollapsible } from '../../../../../enhancers';
import { subscriptionSelect } from '../../../../../actions/subscriptions';
import styles from './UpgradePackage.scss';

function UpgradePackage({ data, onExpand, expanded }) {
  return (
    <div className={styles.root}>
      <Package service={data} />
      <button
        type="button"
        className={classNames('ui-btn', 'ui-btn_secondary', styles.button)}
        onClick={onExpand}
      >
                Upgrade
      </button>
      {
        expanded &&
        <SubscriptionUpgrade
          service={data.id}
          type="upgrade"
          action={({ currentServiceId, servicePriceId, serviceId }) => {
            const session = rpCookie.sharedPermanent.get('rp_guid');

            window.location.href = oneLineTrim`${global.__PRELOADED_STATE__.config.paymentPageUrl}/?action=upgrade
              &returnUrl=${encodeURIComponent(`//${global.location.host}/subscriptions/confirm`)}
              &guid=${session}&currentServiceId=${currentServiceId}
              &servicePriceId=${servicePriceId}
              &serviceId=${serviceId}`;
          }
        }
        />
      }
    </div>
  );
}

export default withCollapsible(state => state.subscriptions, subscriptionSelect)(UpgradePackage);
